import { render, staticRenderFns } from "./LightBoxVideoSpinner.vue?vue&type=template&id=22fcc33b&scoped=true&"
import script from "./LightBoxVideoSpinner.vue?vue&type=script&lang=js&"
export * from "./LightBoxVideoSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LightBoxVideoSpinner.vue?vue&type=style&index=0&id=22fcc33b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcc33b",
  null
  
)

export default component.exports